import { httpsCallable } from "firebase/functions";
import { functions } from "./app";
import { NotificationView } from "../types";
import { memoize } from "../functions";

const remoteGetNotifications = memoize(
  httpsCallable(functions, "getNotifications"),
);

export async function getNotifications(): Promise<NotificationView[]> {
  const result = await remoteGetNotifications();

  return result.data as NotificationView[];
}
